import React from "react";
import { Navigate } from "react-router-dom";
import { useUserAuth } from "./context/AuthContext";
const ProtectedRoute = ({ children }) => {
  const { user } = useUserAuth();

  /*const userAgent = window.navigator.userAgent;
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );
  if (isMobile) {
    return (
      <div className="parent">
        <p>This website is not supported on mobile devices.</p>
      </div>
    );
  }*/

  const localUser = localStorage.getItem("isPubLoggedIn");



  if (!localUser || localUser === "null") {
   
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
